export default "__VITE_ASSET__DMGDoSD4__"